import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "./common/Header";
import Footer from "./common/Footer";
import user from "../images/user.png";
import { callApi } from "./common/API/Api";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { getBaseUrl } from "./common/BaseUrl";
const Reviews = () => {
  let base_image_url = process.env.REACT_APP_IMAGE_URL;
  let base_url = getBaseUrl();
  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = e => setMatches(e.matches);
      mql.addEventListener('change', handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener('change', handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery('(min-width: 1402px)');
  const wrapperRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [pagedata, setPagedata] = useState();
  const location = useLocation();
  const canonicalURL = `https://equlix.com${location.pathname}`;
  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };

    // Initial setup
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }

    // Add scroll and resize listeners
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  const pagecontent = useCallback(async ()=>{
 try {
    let langcode = base_url.split("/")[1]
      let postdata = {};
      let res = await callApi(
        postdata,
        `api/get-review-page?lang=${langcode}`,
        "GET"
      );
      if (res?.data?.success) {
        setPagedata(res?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  },[base_url])
  
  useEffect(() => {
    pagecontent();
  }, [pagecontent]);
 
  return (
    <div className="home">
      <Helmet>
        <title>{pagedata?.meta?.meta_title || "Equlix"}</title>

        <meta
          name="description"
          content={pagedata?.meta?.meta_description || "About Equlix"}
        />
        <meta
          name="keywords"
          content={pagedata?.meta?.meta_keywords || "Equlix Trading Platform"}
        />
        <link rel="canonical" href={canonicalURL} />
      </Helmet>
      <div className="main-page" ref={wrapperRef}>
        <Header />
        <section className="policyConditions reviews_page">
          <div className="container topBorder">
            <div className="row">
              <div className="col-xl-12">
                <div className="sec_title text-left">
                  <h2 className="block_title">
                    {pagedata?.TitleSection[0]?.title?.title}
                  </h2>
                  <p>{pagedata?.TitleSection[0]?.description?.description}</p>
                </div>
              </div>
              {pagedata?.ReviewData?.length
                ? pagedata?.ReviewData.map((result, key) => {
                  return (
                    <div
                      className="col-lg-6 col-md-6 col-sm-12 mt-4"
                      key={key}
                    >
                      <div className="testimonials_box">
                        <div className="testimonials_inner">
                          <div className="testimonials_dt">
                            <div className="dtone">
                              <img
                                src={
                                  result?.image
                                    ? base_image_url + result?.image
                                    : user
                                }
                                alt=""
                              />
                              <h5 className="testnamepos">
                                {result?.name}{" "}
                                <small>{result?.location}</small>
                              </h5>
                            </div>
                            <div className="star_ret">
                              {Array.from({ length: 5 }).map((_, index) => (
                                <i
                                  key={index}
                                  className={
                                    index < parseInt(result?.rating)
                                      ? "fa-solid fa-star"
                                      : "fa-regular fa-star"
                                  }
                                ></i>
                              ))}
                            </div>
                          </div>
                          <p>{result?.message}</p>
                        </div>
                      </div>
                    </div>
                  );
                })
                : ""}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default Reviews;
